import { setTheme } from "theme/default/setTheme";

export const color_00346e = setTheme(({ theme }) => theme.colors.color_00346e);
